import { render, staticRenderFns } from "./Cluster.vue?vue&type=template&id=bc5c0208&scoped=true"
import script from "./Cluster.vue?vue&type=script&lang=js"
export * from "./Cluster.vue?vue&type=script&lang=js"
import style0 from "./Cluster.vue?vue&type=style&index=0&id=bc5c0208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5c0208",
  null
  
)

export default component.exports